import { useEffect } from 'react';

import { Box } from '@/shared/ui';

import { useParams, useSearchParams } from 'react-router';
import { GX_ADDITIONAL_PAPER } from '@/config/colors';

import { useLoginTrip } from '@/features/auth/api/useLoginTrip';
import FactsheetView from '@/features/factsheet/components/FactsheetView';
import {
  ADDITIONAL_TABS_PARAM_NAME,
  FACTSHEET_PARAM_NAME,
  FACTSHEET_TAB_PARAM_NAME
} from '@/features/factsheet/constants';
import { StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';

const Factsheets = () => {
  const params = useParams();
  const factsheetKey = params[FACTSHEET_PARAM_NAME];
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();
  const gxToken = useStorageValue(StorageKeys.GxToken);
  const { mutate: loginTrip } = useLoginTrip();

  const additionalTabsParam = decodeURIComponent(
    urlSearchParams.get(ADDITIONAL_TABS_PARAM_NAME) ?? ''
  );
  const additionalTabs = additionalTabsParam ? additionalTabsParam.split(',') : [];

  const setAdditionalTabsParam = (tabs: string[]) => {
    const newSearchParams = new URLSearchParams(urlSearchParams);

    if (tabs.length === 0) {
      newSearchParams.delete(ADDITIONAL_TABS_PARAM_NAME);
    } else {
      newSearchParams.set(ADDITIONAL_TABS_PARAM_NAME, tabs.join(','));
    }
    if (newSearchParams.get(FACTSHEET_TAB_PARAM_NAME) !== 'Flowchart')
      newSearchParams.delete(FACTSHEET_TAB_PARAM_NAME);
    setUrlSearchParams(newSearchParams);
  };

  useEffect(() => {
    if (gxToken) {
      loginTrip(gxToken);
    }
  }, [gxToken, loginTrip]);

  return (
    <Box
      sx={{
        backgroundColor: `${GX_ADDITIONAL_PAPER}cc`,
        display: 'flex',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh'
      }}
    >
      {factsheetKey && (
        <FactsheetView
          factsheetKeys={[factsheetKey, ...additionalTabs].join(',')}
          setAdditionalTabsParam={setAdditionalTabsParam}
        />
      )}
    </Box>
  );
};

export default Factsheets;
